module.exports = __webpack_public_path__ + "static/media/publisher.c11f2a8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/publisher.svg
// module id = 107
// module chunks = 17